export default __webpack_public_path__ + "static/media/SprengnetterAppsAvmValuation.2d5b1d81.png";